module.exports = __webpack_public_path__ + "img/image15.a9ef4cd3.png";